import React from 'react';
import { DataUploadView } from 'src/features/DataUpload/components/templates/DataUploadView';

export const DataUploadStepWrapper: React.FC = () => {
  return <DataUploadView />;
};
